export class Tag {
  text: string;
  style: string;

  constructor(
    private theText: string,
    private theStyle?: string
  ) {
    this.text = theText;
    this.style = theStyle;
  }
}

export enum GameOrder {
  ONBOARDING,
  DEFAULT,
  LASTPLAY,
  FEATURED,
  TROPHIES,
  BAR,
}
